<div class="bg-white shadow-sm capital-button p-3" role="button">
    <div class="row">
        <div class="col-2 col-lg-3 col-xl-2 d-flex justify-content-center align-items-center">
            <img [src]="icon()" alt="">
        </div>
        <div class="col">
            <p class="button-title m-0">{{ title() }}</p>
            <p class="button-subtitle m-0">{{ subtitle() }}</p>
        </div>
    </div>
</div>